import styled from 'styled-components';
import * as FiIcons from 'react-icons/fi';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  font-family: 'Biotif';
  flex-direction: column;
  background-color: #ffffff;
  margin-left: 10px;
  > h2 {
    margin: 0;
  }
  > h4 {
    margin-bottom: 0px;
  }
`;

export const FlexItem = styled.div`
  display: flex;
`;

export const HeaderContainer = styled(Container)``;

export const DataPrivacyContainer = styled(Container)``;

export const DataPrivacyContent = styled.span`
  padding: 10px;
  background-color: #ebebeb;
  border-radius: 10px;
  margin-right: 10px;
`;

export const NavTextLink = styled.a`
  text-decoration: none;
  width: fit-content;
  font-size: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  border-radius: 4px;
  &.active {
    color: #2dcafc;
  }
`;

export const DocumentsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  margin-top: 20px;
`;

export const DocumentsContainerUpload = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
  cursor: pointer;
`;

export const DocumentContainer = styled.div`
  display: flex;
  width: 330px;
  height: 60px;
  background-color: #f5faff;
  border: 1px dashed #bfcde5;
  border-radius: 10px;
  justify-content: center;
  justify-content: space-between;
  padding: 10px;
`;

export const DocumentContainerFilled = styled.div`
  display: flex;
  align-items: flex-start;
  align-items: center;
  justify-content: center;
  justify-content: space-between;
  width: 330px;
  height: 60px;
  border: 2px solid #f5faff;
  border-radius: 10px;
  padding: 10px;
`;

export const DocumentContainerFilledItems = styled.div`
  display: flex;
  align-items: center;
  > div {
    margin-left: 5px;
  }
`;

export const TrashIcon = styled(FiIcons.FiTrash2)``;

export const DocumentDragAndDropContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const DocumentDragAndDropContainerOnDrop = styled(DocumentDragAndDropContainer)`
  opacity: 0.5;
`;

export const FileLabel = styled.span`
  width: 60%;
  text-align: start;
  font-size: 14px;
`;

export const Divider = styled.hr`
  display: flex;
  margin: 15px 0px 0px 0px;
  border: 1px solid #b6b4bd;
`;

export const DocumentCommentContainer = styled.textarea`
  display: flex;
  width: 330px;
  height: 80px;

  border: 1px solid #bfcde5;
  border-radius: 10px;
  justify-content: center;
  justify-content: space-between;
  padding: 10px;
`;

export const AttentionContainer = styled.div`
  position: relative;
  display: inline-block;
  &:hover {
    > span {
      visibility: visible;
      opacity: 1;
    }
    > img {
      background-color: #ffd460;
      border-radius: 1vh;
    }
  }
`;
export const TooltipText = styled.span`
  visibility: hidden;
  width: 220px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -195px;
  opacity: 0;
  transition: opacity 0.3s;
  &:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 89%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }
`;

export const OthersDocumentsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  margin-top: 20px;
  justify-content: flex-start;
`;
